<template>
  <v-card
    :class="$style.zip_widget"
    :loading="returns_zip_loading"
  >
    <div :class="$style.widget_title">
      <span class="display-3">Возвратные ЗИП</span>
    </div>

    <template v-if="is_filters">
      <div class="d-flex mb-6">
        <v-row>
          <v-col
            cols="12"
            xl="6"
            lg="6"
            md="12"
            sm="6"
            xs="12"
          >
            <Select
              :value="filters.order_side_numbers"
              :items="order_side_numbers"
              :class="[$style.select, $style.filterField]"
              label="№ заказ-наряда"
              multiple
              dense
              hide-details
              clearable
              blue_icon
              @input="filter_update('order_side_numbers', $event, 'returns_zip')"
            />
          </v-col>
        </v-row>
      </div>
    </template>

    <template v-if="is_filters">
      <div
        v-for="item in analytics_returns_zip"
        :key="item.title"
        class="align-start ntch_even"
        :class="$style.widget_item"
      >
        <span
          :class="$style.widget_cert_text"
          class="headline font-weight-regular"
        >
          {{ item.title }}
        </span>
        <span class="headline font-weight-bold">{{ item.value }}</span>
      </div>
    </template>
    <template v-else>
      <div
        v-for="item in returns_zip"
        :key="item.title"
        class="align-start ntch_even"
        :class="$style.widget_item"
      >
        <span
          :class="$style.widget_cert_text"
          class="headline font-weight-regular"
        >{{ item.title }}</span>
        <span class="headline font-weight-bold">{{ item.value }}</span>
      </div>
    </template>
  </v-card>
</template>

<script lang="ts">
import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import { widgets_store, analytics_store } from '@/store';
import { Select } from '@/components/global';
import { AnalyticsFilters } from '@/modules/analytics/types';

const { state } = widgets_store;

const analytics_state = analytics_store.state;

@Component({
  components: {
    Select,
  },
})
export default class WidgetReturnZip extends Vue {
  @Prop({ type: Boolean, default: false })
  is_filters!: boolean;

  @Emit()
  filter_update(key: keyof AnalyticsFilters, value: unknown, section: string) {
    analytics_store.mutations.UPD_FILTER_KEY({ key, value, section });
  }

  get returns_zip() {
    return state.widgets.returns_zip?.items;
  }

  get analytics_returns_zip() {
    const response_filters = this.has_response_filters();

    return response_filters
      ? analytics_state.response_filters.returns_zip.items
      : analytics_state.analytics.returns_zip.items;
  }

  get filters() {
    return analytics_state.filters;
  }

  get order_side_numbers() {
    return analytics_state.order_side_numbers;
  }

  get returns_zip_loading() {
    return analytics_state.returns_zip_loading;
  }

  has_response_filters() {
    return (
      analytics_state.filters.order_side_numbers.length > 0
    );
  }
}
</script>

<style scoped>
.ntch_even {
  background-color: #F6F7FA;
  border-radius: 8px;
}
</style>

<style module lang="scss">
@import '@/scss/common/filter-blocks.scss';

.zip_widget {
  // height: 140px;
  display: flex;
  flex-direction: column;
  padding: 24px;
}
.widget_title {
  margin-bottom: 24px;
  font-style: 24px;
  font-weight: 600;
  line-height: 32px;
  color: #13141C;
}
.widget_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
}
.widget_cert_text {
  width: 192px;
}
.filterField {
  max-width: 100% !important;
}
.datepickerMargin {
  margin-bottom: -14px;
}
</style>
